import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from "@common/hooks/translation";

const DepositQRIframe = ({ name, url }) => {
  const t = useTranslation();

  return (
    <div className="popup-main-content deposit-qr-iframe-content">
      <p className="text-center">{t('To make your deposit, simply scan the QR code using your {1} app.', name)}</p>
      <iframe
        src={url}
        width={320}
        height={320}
      />
    </div>
  );
};

DepositQRIframe.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default DepositQRIframe;